// GENERATED by packages/kvox-web/scripts/sync-brand-identity.mjs from packages/shared/identity.json.
// Never edit by hand: `npm run brand:sync -w @marinoscar/kvox-web` rewrites it,
// `scripts/rename.mjs` runs that on a rebrand and `npm run brand:check` fails on drift.
/**
 * The identity values of `packages/shared/identity.json` that the brand paints.
 *
 * @stability experimental
 */
export const KVOX_IDENTITY = {
    productName: "KVox",
    tagline: "From voice to knowledge.",
    themeColor: "#4f46e5",
    backgroundColor: "#ffffff",
};
